import { BaseQuery } from '../../BaseQuery';
import { TranslationHelper } from '../../../helpers';
import { IQueryContextExternalApiRequest, IQueryOptions } from '../../../models/query';

export abstract class ProviderBase {
	abstract getQuery(queryOptions: IQueryOptions, translationHelper?: TranslationHelper): BaseQuery | undefined;
	public request: IQueryContextExternalApiRequest;
	public constructor(request: IQueryContextExternalApiRequest) {
		this.request = request;
	}
}
